<!-- Mobile Menu Overlay -->
@if (mobileMenuOpen()) {
    <div
        (click)="closeMobileMenu()"
        class="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
    ></div>
}

<!-- Sidebar -->
<aside
    [class.translate-x-0]="mobileMenuOpen()"
    class="fixed lg:static inset-y-0 left-0 w-64 lg:w-48 h-screen z-50 transform -translate-x-full lg:translate-x-0 transition-transform duration-300 ease-in-out"
>
    <!-- Mobile Menu Close Button -->
    <div class="lg:hidden flex justify-end p-4 border-b">
        <button
            (click)="closeMobileMenu()"
            class="p-2 text-gray-600 hover:text-gray-900 rounded-md"
            aria-label="Close menu"
        >
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <nav class="">

        <ul class="">
            <li>
                <a
                    routerLink="/home"
                    routerLinkActive="font-medium"
                    (click)="closeMobileMenu()"
                    class="block px-4 py-2 text-white"
                >
                    Home
                </a>
            </li>
            <li>
                <a
                    routerLink="/selectii"
                    routerLinkActive="font-medium"
                    (click)="closeMobileMenu()"
                    class="block px-4 py-2 text-white"
                >
                    Selectii
                </a>
            </li>
            <li>
                <a
                    routerLink="/rapoarte"
                    routerLinkActive="font-medium"
                    (click)="closeMobileMenu()"
                    class="block px-4 py-2 text-white"
                >
                    Rapoarte
                </a>
            </li>
            <li>
                <a
                    href="#"
                    (click)="closeMobileMenu()"
                    class="block px-4 py-2 text-white"
                >
                    Audit
                </a>
            </li>
            <li>
                <a
                    href="#"
                    (click)="closeMobileMenu()"
                    class="block px-4 py-2 text-white"
                >
                    Configurare
                </a>
            </li>
        </ul>
    </nav>
</aside>
